import { useEffect } from "react";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

export const useSignalRClient = ({
  url = "/hub/clientnotification",
  funcionRespuesta
}) => {

  useEffect(() => {

    // console.log("🚀 Iniciando SignalR...");

    const connection = new HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory: () => localStorage.getItem("token")
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    connection.on("ReceiveNotification", (data) => {
      // console.log("SignalR recibió:", data);
      funcionRespuesta(data);
    });

    connection.onclose((err) => {
      // console.log("Conexión cerrada", err);
    });

    connection.onreconnecting((err) => {
      // console.log("Reconectando...", err);
    });

    connection.onreconnected(() => {
      // console.log(" Reconectado");
    });

    connection.start()
      .then(() => {
        // console.log("SignalR conectado");
        console.log("Estado:", connection.state);
      })
      .catch(err => {
        // console.error(" Error SignalR:", err);
      });

    return () => {
      connection.off("ReceiveNotification");
      connection.stop();
    };

  }, [url, funcionRespuesta]);

  return {};
};